export const collectionOfSpecifiedErrors = [
    'Wrong Email or Password.',
    'User is deactivated.',
    'User should confirm registration.',
    'User should have client.',
    'Client is deactivated.',
    'User does not exist',
];
